// removed by extract-text-webpack-plugin
module.exports = {"FAQ":"src-components-Program-FAQ----FAQ-module---FAQ---20hQB","FAQ__Item":"src-components-Program-FAQ----FAQ-module---FAQ__Item---dybY7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Program/FAQ/FAQ.module.scss
// module id = 733
// module chunks = 100691214015113